// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3Da1J","tab":"ProcedureTabs_tab__1345R"};